<template>
  <div>

    <div class="ibox">
      <div class="ibox-title">
        <strong>Conta e assinatura</strong>
      </div>
      <div class="ibox-content">
        <div class="row app">
          <div class="col-md-12">
            <p><strong>Nome da Conta: </strong>{{ getAccount.name }}</p>
          </div>
          <div class="col-md-12">
            <p><strong>Criado por: </strong>{{ getAccount.responsibleName}}</p>
          </div>
          <div class="col-md-12">
            <p><strong>Data de criação:</strong> {{ getAccount.createdAt | date }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="ibox">
      <div class="ibox-title">
        Apps Contratados
      </div>
      <div style="border-bottom: 1px solid #E1E3EB" v-for="app in installed" :key="app.id">
        <div class="row">
          <div class="col-md-2 my-auto ml-4" style="max-width: 4.33%">
            <div class="icon-card">
              <component v-if="app.icon" :is="app.icon"/>
              <XIcon v-else/>
            </div>
          </div>
          <div class="col-md-10">
            <div class="card-body">
              <h5 class="card-title">{{ app.nickname }}</h5>
              <p class="card-text" v-html="app.description"></p>
              <p v-if="app.subscriptionAt" class="card-text"><small class="text-muted">Contratado em: {{ app.subscriptionAt | datetime }}</small></p>
              <p v-else class="card-text"><small class="text-muted">O período de teste gratuito encerra em: {{ app.expirationAt | datetime }}</small></p>
              <router-link
                  tag="button"
                  class="btn btn-primary btn-md"
                  :to="`/apps/${app.name}`"
              >
                <strong>Mais informações</strong>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import GetAccount from '@/mixins/GetAccount'
  import { mapGetters } from 'vuex'
  import { BookIcon, EditIcon, FileTextIcon, SearchIcon, InfoIcon, MailIcon, XIcon } from 'vue-feather-icons'
  import GetPartner from '@/mixins/GetPartner'
  import { getAppDisplayName } from '@/appDisplayNames'
  import { ACCOUNT_STATUS } from '@/utils/accountStatus'

  export default {
    components: { BookIcon, EditIcon, FileTextIcon, InfoIcon, MailIcon, SearchIcon, XIcon },
    computed: {
      ...mapGetters(['getAccountApps']),
      installed() {
        let installed = this.getAccountApps.map(app => {
          let link = this.links.find(link => link.name === app.name)
          return {
            ...app,
            ...link,
            nickname: getAppDisplayName(app.name, this.getPartner)
          }
        })
        return installed
      },
    },
    data() {
      return {
        links: [
          { name: 'dfe', path: 'dfes' },
          { name: 'message', path: 'messages' },
        ]
      }
    },
    methods: {
      subscriptionType(account) {
        return account.subscriptionType === ACCOUNT_STATUS.TEST ? 'Teste' : 'Padrão'
      }
    },
    mixins: [GetAccount, GetPartner],
    name: 'MyAccount'
  }
</script>

<style scoped>

  .card{
    border: 1px solid #E1E3EB;
    border-radius: 5px 5px 5px 5px;
    height: 100%;
    min-height: 145px;
    box-shadow: 0px 0px 0px 0px;
  }

  .app-content{
    margin: 1em;
  }

  .app-content > div{
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .truncate {
    max-height: 40px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

</style>
